exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{position:relative;min-height:100%}body{margin-bottom:100px}footer{border-top:1px solid #eaeaea;min-height:100px;position:absolute;bottom:0;width:100%;background:#f5f5f5;display:flex;flex-direction:row;align-items:center;justify-content:center}footer ul{list-style-type:none;margin:0}footer ul li{display:inline-block;margin:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/layouts/Footer.css
// module id = ./src/layouts/Footer.css
// module chunks = 2345137460201621000 7489246917808536000 13254968351354405000 17463659626562118000